<!-- Loader -->
<div *ngIf="isLoading" class="fixed inset-0 flex items-center justify-center z-50 backdrop-blur-sm">
  <i class="fas fa-spinner fa-spin text-5xl" style="color:#c19725;"></i>
</div>

<!-- History List -->
<div *ngIf="!isLoading && historyList.length" class="p-4 space-y-6">

  <div *ngFor="let log of historyList"
       class="bg-white border rounded-xl p-4 shadow-sm">

    <!-- Header -->
    <div class="flex justify-between items-start mb-3">
      <div>
        <p class="text-sm font-semibold text-gray-800">
          Assigned to: {{ log.kalakar_name }}
        </p>
        <p class="text-xs text-gray-500">
          {{ log.created_at | date:'dd MMM yyyy, hh:mm a' }}
        </p>
      </div>

      <span class="text-xs px-2 py-1 rounded-full bg-yellow-100 text-yellow-700">
        {{ log.action | titlecase }}
      </span>
    </div>

    <!-- Metals -->
    <div *ngIf="log.metals?.length" class="mb-3">
      <p class="text-sm font-medium text-gray-700 mb-2">Metals</p>

      <div *ngFor="let metal of log.metals"
           class="flex justify-between text-sm border-b border-dashed py-1">
        <span>
          {{ metal.artical_name }} ({{ metal.code }})
        </span>
        <span class="font-semibold">
          {{ metal.quantity }} pcs • {{ metal.total_weight }} gm
        </span>
      </div>
    </div>

    <!-- Stones -->
    <div *ngIf="log.stones?.length">
      <p class="text-sm font-medium text-gray-700 mb-2">Stones</p>

      <div *ngFor="let stone of log.stones"
           class="flex justify-between text-sm border-b border-dashed py-1">
        <span>{{ stone.stone_name }}</span>
        <span class="font-semibold">{{ stone.quantity }} pcs</span>
      </div>
    </div>

  </div>
</div>

<!-- Empty State -->
<div *ngIf="!isLoading && !historyList.length"
     class="text-center py-10 text-gray-500">
  No assignment history found.
</div>
